import { axiosInstance } from '../utils';
import { contractorConstants, shareConstants } from '../constants';
import { flashActions } from './flash';

const getContractorsOptionsForUpload = (search = null, callback) => {
  const params = {
    search,
    page: shareConstants.DEFAULT_PAGE,
    per_page: shareConstants.DEFAULT_PER_PAGE,
    web: true,
  };

  axiosInstance
    .get(contractorConstants.BASE_PATH, { params })
    .then(res => {
      callback(res.data.contractors.map(d => ({ ...d, value: d.id, label: d.name })));
    })
    .catch(() => callback([]));
};

const sendComplianceReminder = contractorId => async dispatch => {
  try {
    const response = await axiosInstance.post(`${contractorConstants.BASE_PATH}/${contractorId}/compliance_reminder`);
    dispatch(flashActions.showSuccess(response.data.message));
    return response.data;
  } catch (error) {
    dispatch(flashActions.showError(error));
  }
};

export const contractorActions = {
  getContractorsOptionsForUpload,
  sendComplianceReminder,
};
